import { LocaleType } from '..'
import zh from './zh-CN.json'
import en from './en.json'

const message = {
  [LocaleType.zhCN]: zh,
  [LocaleType.en]: en,
}

const wordsIsEqual = (word1: string, word2: string) => word1.toLocaleLowerCase() === word2.toLocaleLowerCase()

const fallbackLocale = LocaleType.zhCN
export const useDictionary = (local: LocaleType) => {
  const dictionary = message[local] || message[fallbackLocale]
  const getKeywordDetail = (keyword: string) =>
    dictionary.find(({ title, subTitle }) => wordsIsEqual(title, keyword) || wordsIsEqual(subTitle, keyword))

  const keywords = dictionary.reduce((allKeywords, item) => {
    allKeywords.push(item.title)
    if (item.subTitle) {
      allKeywords.push(item.subTitle)
    }
    return allKeywords
  }, [] as string[])
  return { getKeywordDetail, keywords }
}

type IHighlight = {
  isKeyword: boolean
  text: string
}

/**
 * Highlights keywords in a given text.
 *
 * @param text - The text to search for keywords.
 * @param keywords - An array of keywords to highlight.
 * @returns An array of objects representing the highlighted text.
 */
export function highlightKeywords(text: string, keywords: string[]) {
  const result: IHighlight[] = []
  const pattern = new RegExp(`(${keywords.join('|')})`, 'gi')
  let lastIndex = 0
  let match

  while ((match = pattern.exec(text)) !== null) {
    // 将匹配之前的文本添加到结果数组中
    if (match.index > lastIndex) {
      result.push({ isKeyword: false, text: text.substring(lastIndex, match.index) })
    }

    // 将匹配到的关键词添加到结果数组中
    result.push({ isKeyword: true, text: match[0] })

    // 更新上一次匹配的位置
    lastIndex = pattern.lastIndex
  }

  // 将最后一个关键词之后的文本添加到结果数组中
  if (lastIndex < text.length) {
    result.push({ isKeyword: false, text: text.substring(lastIndex) })
  }
  return result
}
